import React from 'react';
import { FormControl, FormLabel, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import useStyles from '../useStyles';
import PropTypes from 'prop-types';

const workSalaryOptions = [
  { value: 'Casual', label: 'Casual' },
  { value: 'ContractTemp', label: 'Contract' },
  { value: 'FullTime', label: 'Full Time' },
  { value: 'PartTime', label: 'Part Time' }
];

function WorkTypes({ answers, setAnswers }) {
  const classes = useStyles();

  return (
    <FormControl fullWidth={true} className={`${classes.formControl}`}>
      <FormLabel focused={false} className={classes.label}>
        Work Type
      </FormLabel>
      <RadioGroup
        value={answers.listing_work_type}
        onChange={(e) => setAnswers({ ...answers, listing_work_type: e.target.value })}
      >
        {workSalaryOptions.map((pay) => (
          <FormControlLabel
            key={pay.value}
            label={pay.label}
            value={pay.value}
            control={<Radio />}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
}

WorkTypes.propTypes = {
  answers: PropTypes.object.isRequired,
  setAnswers: PropTypes.func.isRequired
};

export default WorkTypes;
